import React from 'react';
import { Box } from '@mui/material';

interface MobileScrollableContentProps {
  children: React.ReactNode;
  paddingBottom?: string;
}

/**
 * MobileScrollableContent - Reusable scrollable content container for mobile settings pages
 * Extracted from MobilePrivacyPolicyPage and MobileTermsConditionsPage
 */
function MobileScrollableContent({
  children,
  paddingBottom = 'clamp(16px, 4vh, 32px)',
}: MobileScrollableContentProps): JSX.Element {
  return (
    <Box
      sx={{
        height: '100%', // Fill the entire available space
        overflowY: 'auto',
        // Hide scrollbar but keep functionality
        '&::-webkit-scrollbar': { display: 'none' },
        scrollbarWidth: 'none',
        pb: paddingBottom, // Bottom padding for scroll space
      }}
    >
      {children}
    </Box>
  );
}

export default MobileScrollableContent;
